import { TranslateService } from '@ngx-translate/core';
import { PageResponse } from '@models/page-response';
import { Role, RoleSearchingCriteria } from './../models/role';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { CommonService } from '@services/common.service';
import { Injectable } from '@angular/core';
import { RoleType } from '../models/role';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';


@Injectable()
export class RoleService {

    constructor(
        private httpClient: HttpClient,
        private commonService: CommonService,
        private translate: TranslateService
    ) { }

    globalSearch(globalCriteria: string = '', criteria: RoleSearchingCriteria, page: number = 0, size: number = 10, sortField: string, sortDirection: string = 'asc'): Observable<PageResponse<Role>> {

        let params: HttpParams = new HttpParams();
        params = params.set('global', globalCriteria);
        params = params.set('criteria', JSON.stringify(criteria == null ? new RoleSearchingCriteria() : criteria));
        params = params.set('page', page.toString());
        params = params.set('size', size.toString());
        if (sortField != null) {
            params = params.set('sort', sortField + ',' + sortDirection);
        }

        return this.httpClient.get(`${environment.API_END_POINT}/roles`, { headers: this.commonService.getHeaders(), params: params })
            .pipe(
                map(response => <PageResponse<Role>>response),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    insert(role: Role): Observable<Role> {

        let body = JSON.stringify(role);

        return this.httpClient.post(`${environment.API_END_POINT}/roles`, body, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response => <Role>(<any>response).content),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    get(id: string): Observable<Role> {
        return this.httpClient.get(`${environment.API_END_POINT}/roles/${id}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response => {
                    return <Role>((<any>response).content);
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    update(role: Role): Observable<Role> {

        let body = JSON.stringify(role);

        return this.httpClient.put(`${environment.API_END_POINT}/roles/${role.roleId}`, body, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response => <Role>((<any>response).content)),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    getRoleByType(roleType: RoleType): Observable<Role[]> {

        let params: HttpParams = new HttpParams();
        params = params.set('roleType', roleType);

        return this.httpClient.get(`${environment.API_END_POINT}/roles`, { headers: this.commonService.getHeaders(), params: params })
            .pipe(
                map(response => <Role[]>((<any>response).content)),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }
}